import { OfferPanel } from './OfferPanel';
export function FinalOffer() {
  return <section id="oferta-final" className="w-full scroll-mt-4 bg-navy-dark py-12 text-white sm:py-16" data-id="element-57" data-mp="g4rbt6tywu5p">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8" data-id="element-58" data-mp="12iqjtme5o9sg">
        <OfferPanel data-id="element-59" data-mp="1gh6tnm7beget" />
      </div>
    </section>;
}